module.exports = __webpack_public_path__ + "static/media/logo.8815269f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/nav/logo.svg
// module id = 231
// module chunks = 0